var TrackingEvent;
(function (TrackingEvent) {
    TrackingEvent["PageView"] = "pageView";
    TrackingEvent["Track"] = "track";
    TrackingEvent["FormSubmit"] = "formSubmit";
    TrackingEvent["FormSuccess"] = "formSuccess";
    TrackingEvent["FormError"] = "formError";
    TrackingEvent["LocatorSearch"] = "locatorSearch";
    TrackingEvent["EcommerceAddItem"] = "ecommerceAddItem";
    TrackingEvent["EcommerceRemoveItem"] = "ecommerceRemoveItem";
    TrackingEvent["EcommerceCheckout"] = "ecommerceCheckout";
    TrackingEvent["WebVitalsMetric"] = "webVitalsMetric";
})(TrackingEvent || (TrackingEvent = {}));
export default TrackingEvent;
